module.exports = __webpack_public_path__ + "static/flags/IT-f1aec4f27639502028a324dc4518aad4.gif";